import React from 'react'
import { MenuItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import Assets from 'app/configs/assetConfigs'

const useStyle = makeStyles((theme) => ({
  deleteMenu: {
    color: theme.palette.negative.main,
  },
}))

const DeleteMenuItem = ({ onClick, selectedCount }) => {
  const classes = useStyle()
  return (
    <MenuItem onClick={onClick}>
      <ListItemIcon className="min-w-40">
        <img alt="Delete Icon" src={Assets.deleteOutline} />
      </ListItemIcon>
      <ListItemText
        className={clsx(classes.deleteMenu)}
        primary={
          <FormattedMessage
            id="teamMembers.table.action.deleteAll.label"
            values={{ count: selectedCount }}
          />
        }
      />
    </MenuItem>
  )
}

export default DeleteMenuItem
